import axios from 'axios'
import {useEffect, useState, useRef} from "react";
import { yesNo } from '../../functions/functions';
import { formValid, resetFieldsErrors } from '../../functions/form';
import Modal from '../elements/Modal';
import Select from "../elements/Select";
import {setError} from "../../slices/error/ErrorSlice";
import {setDined} from "../../slices/error/AccessSlice";
import {useDispatch, useSelector} from "react-redux";
import withAccess from "../hoc/withAccess";
import { useProsmTypeListQuery, usePermissionListQuery } from "../../slices/api/apiSlice";

const Users = () => {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [permissionsForm, setPermissionsForm] = useState({})
    const kodFito = useSelector(state => state.voc.kodfito);
    const [userForm, setUserForm] = useState({
        login: '',
        password: '',
        name_rus: '',
        description: '',
        domain: '',
        signature: '',
        is_active: true,
        type: 1,
        type2: 999
    });
    const [edit, setEdit] = useState(false);
    const [idEdit, setIdEdit] = useState(null)
    const [idDel, setIdDel] = useState(null);
    const [loginDel, setLoginDel] = useState(null);
    let initialUserForm = useRef(userForm);
    const formRefs = useRef({
        login: useRef(null),
        password: useRef(null),
        name_rus: useRef(null),
        description: useRef(null),
        domain: useRef(null),
        signature: useRef(null)
    });

    const prosmTypeQuery = useProsmTypeListQuery(null);
    const permissionsQuery = usePermissionListQuery(null);

    useEffect(() => {
        getUsers()

        // setPermissions(perm.data);

        let permissionsFormData = {};

        for (let key in permissionsQuery.data) {
            permissionsFormData[permissionsQuery.data[key]['code']] = false
        }

        setPermissionsForm(permissionsFormData);
        initialUserForm.current.permissions = permissionsFormData;
    }, []);

    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);

    function getUsers() {
        axios.get('/api/user/list')
            .then(res => {
                setUsers(res.data);
            })
            .catch(e => {
                if (e.status === 403) {
                    dispatch(setDined(true));
                }
            })
    }

    function modalToggler() {
        setModalShow(!modalShow);
    }

    function openModalDelHandler(e) {
        setIdDel(Number(e.currentTarget.parentNode.parentNode.firstElementChild.innerHTML));
        setLoginDel(e.currentTarget.parentNode.parentNode.firstElementChild.nextSibling.childNodes[0].innerHTML)
        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setIdDel(null);
        setLoginDel(null);
    }

    function resetFormCloseModal() {
        setUserForm(initialUserForm.current);
        setPermissionsForm(initialUserForm.current.permissions)
        setEdit(false);
        setIdEdit(null);
        resetFieldsErrors(formRefs.current);
        modalToggler();
    }

    function createHandler() {
        resetFieldsErrors(formRefs.current);

        axios.post('/api/user/create', Object.assign(userForm, {permissions: permissionsForm}))
            .then(res => {
                console.log('user created');
                resetFormCloseModal();
                getUsers();
            })
            .catch(e => {
                console.log(e.response.data.detail)
                let objErr = JSON.parse(e.response.data.detail)
                // console.log(objErr);
                // console.log(formRefs.current)
                formValid(formRefs.current, objErr);
            })
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        if (e.target.name === 'type' || e.target.name === 'type2') value = Number(value)

        if (e.target.type === 'checkbox') {
            if (e.target.name === 'is_active') {
                setUserForm({...userForm, [fieldName]: e.target.checked});
            } else setPermissionsForm({...permissionsForm, [fieldName]: e.target.checked});
        } else setUserForm({...userForm, [fieldName]: value});
    }

    function userHandler(e) {
        const id = e.target.parentNode.previousSibling.innerHTML;
        setIdEdit(id);
        setEdit(true);

        axios.get(`/api/user/${id}`)
            .then(res => {
                setUserForm(res.data);
                setPermissionsForm(res.data.permissions);
                modalToggler();
            })
    }

    function editHandler(e) {
        axios.post(`/api/user/${idEdit}/edit`, Object.assign(userForm, {permissions: permissionsForm}))
            .then(res => {
                console.log('user updated');
                resetFormCloseModal();
                getUsers();
            })
            .catch(e => {
                console.log(e.response.data.detail)
                let objErr = JSON.parse(e.response.data.detail)
                formValid(formRefs.current, objErr);
            })
    }

    function delHandler() {
        axios.delete(`/api/user/${idDel}/del`)
            .then(res => {
                console.log('user deleted');
                closeModalDelHandler();
                getUsers();
            })
    }


    let rowsUser = users.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td><span className="link hover" onClick={userHandler}>{item.login}</span></td>
            <td>{item.name_rus}</td>
            <td>{item.opisanie}</td>
            <td>{item.domain}</td>
            <td>{yesNo(item.is_active)}</td>
            <td>{yesNo(item.l_admin)}</td>
            <td>{yesNo(item.l_vvod)}</td>
            <td>{yesNo(item.l_prosm)}</td>
            <td>{yesNo(item.l_another_edit)}</td>
            <td>{yesNo(item.l_history_change)}</td>
            <td>{yesNo(item.l_voc)}</td>
            <td>{yesNo(item.l_struc)}</td>
            <td>{yesNo(item.fssrb)}</td>
            <td>{yesNo(item.fsscntrl)}</td>
            <td>{yesNo(item.klicntrl)}</td>
            <td>{yesNo(item.rep_xml)}</td>
            <td>{item.prosm_type}</td>
            <td>{item.kod_fito}</td>
            <td>
                <svg onClick={openModalDelHandler} width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
</tr>
)

    let rowsPermissions = permissionsQuery.data && permissionsQuery.data.map(item =>
        <div className="form-check form-check-reverse text-start" key={item.id}>
            <label className="form-check-label col-sm-6 px-2" htmlFor="activeCheck">
                {item.name}
            </label>
            <input className="form-check-input float-none ms-2" type="checkbox"
                   onChange={changeHandler} checked={permissionsForm[item.code]} name={item.code}
            />
        </div>
    )

    return (
        <>
            <Modal
                header={edit ? 'Редактирование пользователя' : 'Создание пользователя'}
                show={modalShow}
                closeHandler={resetFormCloseModal}
            >
                <div onChange={changeHandler}>
                    <div className="mb-3 row">
                        <label htmlFor="inputLogin" className="col-sm-4 col-form-label">Логин</label>
                        <div className="col-sm-8">
                            <input type="text" name='login' className="form-control" id="login" ref={formRefs.current.login}
                                   onChange={changeHandler} value={userForm.login}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row" style={{ display: edit ? '' : '' }}>
                        <label htmlFor="password" className="col-sm-4 col-form-label">Пароль</label>
                        <div className="col-sm-8">
                            <input type="password" name='password' className="form-control" id="password" ref={formRefs.current.password}
                                   onChange={changeHandler} value={userForm.password}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor="inputWho" className="col-sm-4 col-form-label">Кто</label>
                        <div className="col-sm-8">
                            <input type="text" name='name_rus' className="form-control" id="name_rus" ref={formRefs.current.name_rus}
                                   onChange={changeHandler} value={userForm.name_rus}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor="inputDesc" className="col-sm-4 col-form-label">Описание</label>
                        <div className="col-sm-8">
                            <input type="text" name='description' className="form-control" id="description" ref={formRefs.current.description}
                                   onChange={changeHandler} value={userForm.description}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor="inputDomain" className="col-sm-4 col-form-label">Домен</label>
                        <div className="col-sm-8">
                            <input type="text" name='domain' className="form-control" id="domain" ref={formRefs.current.domain}
                                    onChange={changeHandler} value={userForm.domain}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor="inputSignature" className="col-sm-4 col-form-label">Буквы для № заявки</label>
                        <div className="col-sm-8">
                            <input type="text" name='signature' className="form-control" id="signature" ref={formRefs.current.signature}
                                    onChange={changeHandler} value={userForm.signature}
                            />
                        </div>
                    </div>
                    <div className="form-check form-check-reverse text-start">
                        <label className="form-check-label col-sm-6 px-2" htmlFor="activeCheck">Активность</label>
                        <input className="form-check-input float-none ms-2" type="checkbox" name='is_active'
                               onChange={changeHandler} checked={userForm.is_active} id="activeCheck"
                        />
                    </div>

                    {rowsPermissions}

                    <div className="my-3 row">
                        <label htmlFor="inputType" className="col-sm-4 mt-1 col-form-label">Тип</label>
                        <div className="col-sm-8">
                            <Select data={prosmTypeQuery.data ? prosmTypeQuery.data : []} name='type'  value={userForm.type} handler={changeHandler}/>
                        </div>
                    </div>
                    <div className="my-3 row">
                        <label htmlFor="inputType" className="col-sm-4 col-form-label">Тип2</label>
                        <div className="col-sm-8">
                            <Select data={kodFito} name='type2' value={userForm.type2} handler={changeHandler}/>
                        </div>
                    </div>
                </div>

                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom' onClick={edit ? editHandler : createHandler}
                           value='Сохранить'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={resetFormCloseModal} value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить пользователя'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{loginDel}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                        <input type='button' className='btn mb-0 btn-success margin-botom'
                               onClick={delHandler}
                               value='Да'/>
                        <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                               value='Нет'/>
                </div>
            </Modal>

            <h1>Пользователи</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalToggler}
                   value='Создать пользователя'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Логин</th>
                    <th scope="col">Кто</th>
                    <th scope="col">Описание</th>
                    <th scope="col">Домен</th>
                    <th scope="col">Активность</th>
                    <th scope="col">Админ</th>
                    <th scope="col">Ввод</th>
                    <th scope="col">Просмотр</th>
                    <th scope="col">Ред. чуж. записи</th>
                    <th scope="col">Просм. истор. изм.</th>
                    <th scope="col">Словари</th>
                    <th scope="col">Структура</th>
                    <th scope="col">ФСС РБ</th>
                    <th scope="col">ФСС контроль</th>
                    <th scope="col">Клиент контроль</th>
                    <th scope="col">XLS отчёт</th>
                    <th scope="col">Тип</th>
                    <th scope="col" style={{width: 100}}>Тип2</th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                    {rowsUser}
                </tbody>
            </table>
        </>
    )
}

const UsersWithAccess = withAccess(Users);
export default UsersWithAccess;